var map = {
	"./biztositas-javitas.png": "2152",
	"./fizetos-javitas.png": "0ce9",
	"./garancia-segitseg.png": "4806",
	"./garancialis-javitas.png": "1a66",
	"./halozat_kep3.png": "7250",
	"./javitas_kep4.png": "67cd",
	"./logisztika_kep1.png": "3024",
	"./presales_kep2.png": "0b26"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "61b0";